import EmailRecoveryForm from './EmailRecoveryForm';

export default EmailRecoveryForm;
